<template>
  <div class="station-view">

    <StationButtonGroup>
      <StationButtonGroupButton class="col-3" :active="cuttingTabIndex == 0" @click="selectScanPanelsMode">
        SCAN PANELS
      </StationButtonGroupButton>
      <StationButtonGroupButton class="col-3" :active="cuttingTabIndex == 1" @click="selectGlassCuttingMode">
        GLASS SHEET CUTTING
      </StationButtonGroupButton>
      <StationButtonGroupButton class="col-3" :active="cuttingTabIndex == 2" @click="selectCuttingLogMode">
        CUTTING LOG
      </StationButtonGroupButton>
      <StationButtonGroupButton class="col-3" :active="cuttingTabIndex == 3" @click="selectBatchTab">
        BATCH
      </StationButtonGroupButton>
    </StationButtonGroup>

    <br /><br />

    <!-- Panel Scanning -->
    <CuttingPanelScanPage
      ref="cuttingPanelScanPage"
      v-show="cuttingTabIndex == 0"
      :productionStage="productionStage"
      :productionStation="productionStation"
    />

    <!-- Glass Sheet Consume -->
    <CuttingSheetScanPage
      ref="cuttingSheetScanPage"
      v-show="cuttingTabIndex == 1"
      :productionStage="productionStage"
      :productionStation="productionStation"
    />

    <!-- Cutting History -->
    <CuttingLogPage
      ref="cuttingLogPage"
      v-show="cuttingTabIndex == 2"
      :productionStage="productionStage"
      :productionStation="productionStation"
    />

    <!-- Cutting Batch -->
    <CuttingBatchPage
      ref="cuttingBatchPage"
      v-show="cuttingTabIndex == 3"
      @panelClick="batchPanelClicked"
      :showItemDrop="showBatchDrop"
      :productionStage="productionStage"
      :productionStation="productionStation"
    />
  </div>
</template>

<style lang="scss" scoped>
.station-cutting-view {
  flex: 100%;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items:stretch;
  overflow-x: hidden;
}
</style>

<script>
import _ from 'lodash'
import moment from 'moment'
import dragula from 'dragula'
import 'dragula/dist/dragula.css'

import formMixin from '@/mixins/form'
import Utils from '@/utils/utils'

import StationButtonGroup from '@/apps/glass-production-station/src/components/main/stationButtonGroup'
import StationButtonGroupButton from '@/apps/glass-production-station/src/components/main/stationButtonGroupButton'

import CuttingPanelScanPage from '@/apps/glass-production-station/src/components/station/cuttingPanelScanPage'
import CuttingSheetScanPage from '@/apps/glass-production-station/src/components/station/cuttingSheetScanPage'
import CuttingLogPage from '@/apps/glass-production-station/src/components/station/cuttingLogPage'
import CuttingBatchPage from '@/apps/glass-production-station/src/components/station/cuttingBatchPage'

export default {
  name: 'ManualCuttingStationView',
  mixins: [formMixin],
  components: {
    StationButtonGroup,
    StationButtonGroupButton,
    CuttingPanelScanPage,
    CuttingSheetScanPage,
    CuttingLogPage,
    CuttingBatchPage
  },
  props: {
    productionStage: Object,
    productionStation: Object
  },
  data() {
    return {
      cuttingTabIndex: 0,
      showBatchDrop: false,
    }
  },
  mounted() {
    let stationView = this
    this.$options.drake = dragula([], {
      copy: true,
      removeOnSpill: true,
      revertOnSpill: true,
      slideFactorX: 5,
      slideFactorY: 5,
      isContainer: function(el) {
        if(el.classList.contains('station-batch-draggable-container') || el.classList.contains('station-batch-droppable-container'))
          return true

        return false
      },
      moves: function (el, source, handle, sibling) {
        return el.classList.contains('station-batch-draggable');
      },
      accepts: function (el, target, source, sibling) {
        if(!el)
          return false

        if(el.dataset.orderid && el.dataset.type == 'order') {
          if(target.classList.contains('station-batch-droppable-container'))
            return true
        }
          
        if(el.dataset.panelid && el.dataset.type == 'glass') {
          if(target.classList.contains('station-batch-droppable-container'))
            return true
        }

        return false
      }
    })
    this.$options.drake.on('out', (el, container, source) => {
      let isBatchDraggable = el.classList.contains('station-batch-draggable')

      if(isBatchDraggable && container.classList.contains('station-batch-droppable-container'))
        stationView.showBatchDrop = false
    })
    this.$options.drake.on('over', (el, container, source) => {
      let isBatchDraggable = el.classList.contains('station-batch-draggable')

      if(isBatchDraggable && container.classList.contains('station-batch-droppable-container'))
        stationView.showBatchDrop = true
    })
    this.$options.drake.on('drop', (el, container, source) => {
      this.$options.drake.cancel(true)

      if(container.classList.contains('station-batch-droppable-container')) {
        if(el.dataset.panelid && el.dataset.type == 'glass')
          stationView.addPanelToBatchPage(parseInt(el.dataset.panelid))
        if(el.dataset.orderid && el.dataset.type == 'order')
          stationView.addOrderToBatchPage(parseInt(el.dataset.orderid))
      }
    })
  },
  methods: {
    selectScanPanelsMode() {
      this.cuttingTabIndex = 0
      this.$refs.cuttingPanelScanPage.pageSelected()
    },
    selectGlassCuttingMode() {
      this.cuttingTabIndex = 1
      this.$refs.cuttingSheetScanPage.pageSelected()
    },
    selectCuttingLogMode() {
      this.cuttingTabIndex = 2
      this.$refs.cuttingLogPage.pageSelected()
    },
    selectBatchTab() {
      this.cuttingTabIndex = 3
      this.$refs.cuttingBatchPage.pageSelected()
    },
    batchPanelClicked(info) {
      this.$emit('panelClick', { panel: info.panel, target: info.target, forceElement: true })
    },
    addPanelToBatchPage(panelId) {
      this.$refs.cuttingBatchPage.addPanelToBatchPage(panelId);
    },
    addOrderToBatchPage(orderId) {
      this.$refs.cuttingBatchPage.addOrderToBatchPage(orderId);
    }

  }
  
}
</script>